import dotPropImmutable from 'dot-prop-immutable';
export const variablesSlice = {
    setConditionalVariables: (state, { payload })=>{
        const { variableId, formValues, templateId } = payload;
        const path = `${templateId}.template.templateMeta.conditionalVariables`;
        const _payload = {
            formValues
        };
        return dotPropImmutable.merge(state, path, {
            [variableId]: _payload
        });
    },
    removeConditionalVariables: (state, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    { payload })=>{
        // const { variableId } = payload;
        // const path = `data.${state.activeId}.template.templateMeta.conditionalVariables.${variableId}`;
        /**
     * TODO: mark the variable as deleted
     * and unmark the same on undo
     * and on template save, delete the variables marked as deleted
     * before making API call.
     */ return state;
    // return {
    //   ...state,
    //   ...dotPropImmutable.delete(state, path),
    // };
    }
};
